import React from 'react';

import appConfig from '../../config/appConfig';
import AccessibilityToolChecker from '../ServiceContainers/AccessibilityToolChecker/AccessibilityToolChecker';
import AccessibilityTool from './AccessibilityTool/AccessibilityTool';

const Accessibility = () => {
    const isAccessibilityToolEnabled = appConfig.getIsAccessibilityToolEnabled();

    return (
        <>
            {isAccessibilityToolEnabled && <AccessibilityTool />}
            {isAccessibilityToolEnabled && <AccessibilityToolChecker />}
        </>
    );
};

export default Accessibility;
